import { render } from "./caseList.vue?vue&type=template&id=d2145dd4&scoped=true&ts=true"
import script from "./caseList.vue?vue&type=script&lang=ts"
export * from "./caseList.vue?vue&type=script&lang=ts"

import "./caseList.vue?vue&type=style&index=0&id=d2145dd4&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2145dd4"]])

export default __exports__